(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			lazyLoad: 'ondemand',
		});
	};

	var heroVideo = function() {

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
		});

	};


	var scrollAnim = function(){

		///** convert to use intersectionObserver **///

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0 && !locationHashObj.hasClass('tab') ){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					// var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					var finalPosition = anchorPosition - $('.site-header').outerHeight();
					$("html, body").animate({scrollTop: finalPosition}, 1000);


				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href*="#"]').on('click', function(e){

			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						// var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						var finalPosition = anchorPosition - $('.site-header').outerHeight();
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	var blockGallery = function() {
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		});
	};

	var faqs = function() {

		$('[data-action="faq"]').on('click', function(e) {
			e.preventDefault();

			$(this).toggleClass('open');
		});
	};

	var readMore = function() {
		 $('[data-action="readmore"]').on('click', function(e){
		 	e.preventDefault();
		  	var targetId = $(this).data('target');

		  	$(this).toggleClass('vis');
		  	$('#'+targetId).toggleClass('vis');
		});
	};

	var homeTabs = function() {

		if( location.hash ){
			// window.scrollTo(0,0);

			// $( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $('a[href="'+location.hash+'"]');
			
			if(locationHashObj.length > 0){
				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}
				
				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight();
					$("html, body").animate({scrollTop: finalPosition}, 1000);

					locationHashObj.trigger('click');

				}, waitTime);
			}
		}

		$('[data-action="home-tab"]').on('click', function(e) {
			e.preventDefault();

			var thisLabel = $(this).parents('.tab-label');
			var target = $(this.hash);

			// console.log(this.hash);

			$('.home-tabs').find('.tab-label').not(thisLabel).removeClass('active');
			thisLabel.addClass('active');

			$('.home-tabs').find('.tab').not(target).removeClass('active');
			target.addClass('active');
		});

		$('.gallery-thumbs').on('click', '[data-action="thumb"]', function(e) {
			e.preventDefault();
			
			var thisGallery = $(this).parents('.gallery').find('.gallery-main');
			// var thisHref = this.href;
			var thisHref = $(this).attr('href');
			var thisIndex = $(this).attr('data-index');
			var thisSrc = $(this).find('img').attr('src');

			thisGallery.find('a').attr('href', thisHref);
			thisGallery.find('a').attr('data-index', thisIndex);
			thisGallery.find('img').attr('src', thisSrc);
		});

		// 2. Initialize Magnific Popup on gallery click
		$('.gallery-main').on('click', '[data-action="gallery"]', function(e) {
			e.preventDefault();

			var thisIndex = parseInt($(this).attr('data-index'));

			// Get all image URLs dynamically
			var items = $(this).parents('.gallery').find('.gallery-thumbs').find('a').map(function() {
				return {
					src: $(this).attr('href'),
					type: 'image'
				};
			}).get();

			// console.log(thisIndex);

			// Open Magnific Popup
			$.magnificPopup.open({
				items: items,
				gallery: {
					enabled: true,
				},
				type: 'image'
			}, thisIndex);
		});

	};

	var homeSlider = function() {
		$('.home-slider').find('.slider').slick({
			arrows: true,
			prevArrow: false,
			nextArrow: '.slider-next',
			dots: false,
			speed: 1000,
			// autoplay: true,
			// autoplaySpeed: 4000,
			pauseOnHover: false,
			lazyLoad: 'ondemand',
		});
	};

	var testimonialSlider = function() {
		$('.home-testimonial-slider').slick({
			arrows: true,
			prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.78 54.99"><path d="M.32,28.32l11.11,11.11,15.2,15.2c.47.47,1.22.47,1.67,0l11.11-11.11c.47-.47.47-1.22,0-1.67l-14.35-14.35,14.35-14.35c.47-.47.47-1.22,0-1.67L28.31.36c-.47-.47-1.22-.47-1.67,0l-15.18,15.18L.35,26.65c-.22.22-.35.55-.35.85s.12.6.35.85l-.02-.02Z" fill="#fff"/></svg></button>',
			nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.78 54.99"><path d="M39.46,26.67l-11.11-11.11L13.14.36c-.47-.47-1.22-.47-1.67,0L.36,11.47c-.47.47-.47,1.22,0,1.67l14.35,14.35L.36,41.85c-.47.47-.47,1.22,0,1.67l11.11,11.11c.47.47,1.22.47,1.67,0l15.18-15.18,11.11-11.11c.22-.22.35-.55.35-.85s-.12-.6-.35-.85l.02.02Z" fill="#fff"/></svg></button>',
			dots: false,
			speed: 1000,
			// autoplay: true,
			// autoplaySpeed: 4000,
			pauseOnHover: false,
			lazyLoad: 'ondemand',
		});
	};

	$(document).ready(function(){
		homeHeroSlider();
		heroVideo();
		scrollAnim();
		scrollToAnchor();
		blockGallery();
		faqs();
		readMore();
		homeTabs();
		homeSlider();
		testimonialSlider();
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');
    }, false);

})(jQuery);

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });